module.exports = __webpack_public_path__ + "static/media/bubbles.f646d45c.png";